<template>
    <div>
        <ul v-if="collapsed" class="list-group list-group-horizontal-sm m-2 text-blue-500">
            <li class="open-btn"
              v-tooltip="'Share on social media'"
              @click="toggleMenu(0)"
            >
              <i class="fas fa-share-alt"></i>
            </li>
        </ul>

        <ul v-if="!collapsable || !collapsed" class="list-group list-group-horizontal-sm m-2 text-gray-500">
            <div v-for="(option, index) in options" :key="'opt-' + index">
                <ShareNetwork
                  v-if="index < getCloseOptionIndex()"
                  :network="option.networkId"
                  :url="resourceUrl"
                  :title="resourceTitle"
                  :description="resourceDescription"
                >
                  <li class="list-group-item" :class="{ 'list-group-item-first': index === 0 }" v-tooltip="option.tooltip">
                      <i :class="option.faIconClasses"></i>
                  </li>
                </ShareNetwork>

                <li v-if="index == getCloseOptionIndex()" class="list-group-item list-group-item-last" v-tooltip="option.tooltip" @click="toggleMenu(index)">
                  <i :class="option.faIconClasses"></i>
                </li>
            </div>
        </ul>
    </div>
</template>

<script>

export default {
    props: {
        collapsable: {
            type: Boolean,
            default: true
        },
        resourceUrl: {
            type: String
        },
        resourceTitle: {
            type: String,
            default: ''
        },
        resourceDescription: {
            type: String,
            default: ''
        }
    },
    
    data() {
        return {
            collapsed: this.collapsable,
            // a list of social media platforms represented by name and fontawesome icon class
            availablePlatforms: [
                {
                    name: 'Facebook',
                    networkId: 'facebook',
                    faIconClasses: 'fab fa-facebook-f'
                },
                {
                    name: 'Twitter',
                    networkId: 'twitter',
                    faIconClasses: 'fab fa-twitter'
                },
                {
                    name: 'Linked In',
                    networkId: 'linkedin',
                    faIconClasses: 'fab fa-linkedin-in'
                },
                {
                    name: 'Email',
                    networkId: 'email',
                    faIconClasses: 'fas fa-envelope'
                }
            ]
        };
    },

    methods: {
        getCloseOptionIndex() {
            return this.availablePlatforms.length;
        },

        toggleMenu(clickedOptionIndex) {
            if (this.collapsed) {
                this.collapsed = false;
            } else if (clickedOptionIndex == this.getCloseOptionIndex()) {
                this.collapsed = true;
            }
        },

        getShareTooltip(platformName) {
            return `Share via ${platformName}`;
        }
    },

    computed: {
        options() {
            const options = [];

            if (!this.collapsable || !this.collapsed) {
                for (let socialPlatform of this.availablePlatforms) {
                    options.push({
                        tooltip: this.getShareTooltip(socialPlatform.name),
                        faIconClasses: socialPlatform.faIconClasses,
                        networkId: socialPlatform.networkId
                    });
                }
            }

            if (this.collapsable && !this.collapsed) {
                options.push({
                    tooltip: 'Close',
                    faIconClasses: 'fas fa-times-circle'
                });
            }

            return options;
        }
    }
}
</script>

<style scoped>
.list-group {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: row;
    flex-direction: row;
    padding-left: 0;
    margin-bottom: 0;
    border-radius: .25rem;
}

.list-group-item {
    position: relative;
    display: block;
    padding: .75rem 1.25rem;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,.125);
    cursor: pointer;
}

.list-group-item-first {
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
}

.list-group-item-last {
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
}

.open-btn {
    position: relative;
    display: block;
    padding: .75rem 1.25rem;
    cursor: pointer;
}

</style>
